<div class="bloco">
  <h5 class="titulo">Sócios</h5>
  <div *ngIf="naoEncontrouRegistros">
      <div class="row">
        <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
      </div>
  </div>
  <div *ngIf="naoSolicitou">
      <div class="row">
          <div class="col-auto item">Você não solicitou essa consulta.</div>
        <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
      </div>
  </div>
  <div *ngIf="dados.socio">
    <div class="row">
      <table class="table table-sm ">
        <thead>
          <tr>
            <th>Tipo Doc.</th>
            <th>Documento</th>
            <th>Nome</th>
            <th>Cargo</th>
            <th>Responsável legal</th>
            <th>Cargo Resp. legal</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of dados.socio">
            <td>{{row.tipo_documento}}</td>
            <td id="documentoSocio">
              <i class="fas fa-search"></i> 
              <a 
                href="javascript:void(0)" 
                tooltip="Clique aqui para consultar este documento {{row.documento | mascara:'cpf'}}"
                (click)="capturaDoc(row.documento)"
                routerLink="/area-logada/consultas"> 
                  {{row.documento  | mascara:'cpf'}}
              </a>
            </td>
            <td>{{row.nome_rf}}</td>
            <td>{{row.cargo}}</td>
            <td>{{row.responsavel_legal}}</td>
            <td>{{row.cargo_responsavel_legal}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  
  